<template>
    <PopupRouterView :showLeftIcon="true" label="Repacking Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="repacking"
        @hideMethod="onHidden"
        ref="repackingInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-datepicker  id="fieldset-repack-date" class="input-label-detail mb-5" label-cols-lg="12"  label="Repack Date" size="sm" :model.sync="repackDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isEditable="false" :isUpdatable="false" />
						<app-input-textbox id="fieldset-part-number" ref="fieldset-part-number" 
							:model.sync="partNumberQrCode" label="Part Number" 
							@keyupMethod="getPartsWithoutLoading"
							@enterMethod="scanPartNumber"
							:isBusy="isScanPartNumberLoading" 
							 />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="parts != null && parts.length > 0">
							<app-list :isDataLoading="isPartsLoading" :dataCount="parts.length">
								<part-item v-for="(item,index) in parts" :model="item" :key="index" @nextAction="goToNext(2, item)" />
							</app-list>
						</span>
					</b-col>
				</b-row>
			</span>

			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="12">
						<app-input-datepicker  id="fieldset-repack-date" class="input-label-detail mb-5" label-cols-lg="12"  label="Repack Date" size="sm" 
							:model.sync="repackDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" 
							:isEditable="false" :isUpdatable="false" />
						<app-label label-cols-lg="12" size="sm" label="Part No" :model="selectedPart.partNumber" />
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="selectedPart.partName" />
						<app-input-textbox id="fieldset-delivery-order" ref="fieldset-delivery-order" 
							:model.sync="doQrCode" label="Delivery Order" 
							@keyupMethod="getDeliveryOrdersWithoutLoading"
							@enterMethod="scanDeliveryOrder"
							:isBusy="isScanDeliveryOrderLoading" 
							 />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="deliveryOrders != null && deliveryOrders.length > 0">
							<app-list :isDataLoading="isDeliveryOrderLoading" :dataCount="deliveryOrders.length">
								<delivery-item v-for="(item,index) in deliveryOrders" :model="item" :key="index" @nextAction="goToNext(3, item)" />
							</app-list>
						</span>
					</b-col>
				</b-row>
			</span>
        </div>

        <b-overlay :show="isBusy" no-wrap></b-overlay>

        <template #modal-action-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right" @click="gotoPrevious(1)">Back</b-button>
		</template>

    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import Repacking from '@/models/Repacking/Repacking';
import RepackingList from '@/models/Repacking/RepackingList';
import RepackingFilter from '@/filters/Repacking/RepackingFilter';
import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import RepackStatus from '@/models/RepackStatus/RepackStatus';
import RepackStatusFilter from '@/filters/RepackStatus/RepackStatusFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import RepackingDetail from '@/models/Repacking/RepackingDetail';
import RepackingDetailFilter from '@/filters/Repacking/RepackingDetailFilter';
import RepackingControlCard from '@/models/Repacking/RepackingControlCard';
import RepackingControlCardFilter from '@/filters/Repacking/RepackingControlCardFilter';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import RepackingDetailInput from '@/views/Repacking/RepackingDetailInput';
import RepackingDetailScan from '@/views/Repacking/RepackingDetailScan';
import RepackingDetailUpload from '@/views/Repacking/RepackingDetailUpload';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import RepackingControlCardInput from '@/views/Repacking/RepackingControlCardInput';
import RepackingControlCardScan from '@/views/Repacking/RepackingControlCardScan';
import RepackingControlCardUpload from '@/views/Repacking/RepackingControlCardUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PartItem from './components/PartItem';
import DeliveryItem from './components/DeliveryItem';

export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		RepackingDetailInput,
		RepackingDetailScan,
		RepackingDetailUpload,
		RepackingControlCardInput,
		RepackingControlCardScan,
		RepackingControlCardUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppList,
		PartItem,
		DeliveryItem,
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
		},
	},
	data() {
		return {
			busy:false,
			isBusy: false,
			isDataLoading: false,
			modelId: null,
			model: {},
			scanPageIndex: 1,

			partNumberQrCode: '',
			repackingId: null,
			isScanPartNumberLoading: false,
			isPartsLoading: false,
			parts: [],
			selectedPart: {},

			repackDate: new Date(),
			doQrCode: '',
			isScanDeliveryOrderLoading: false,
			isDeliveryOrderLoading: false,
			deliveryOrders: [],
			selectedDeliveryOrder: {},
		}
	},
	methods : {
		getParts : async function(input) {
			this.isPartsLoading = true;
			let qrCode = encodeURIComponent(this.partNumberQrCode)
			await Repacking.getPartList(this, qrCode, this.repackingId)
			.then(result => {
				if (result != null) {
					this.parts = result
				}
				this.isPartsLoading = false;
			})
			.catch(error => {});
		},
		getPartsWithoutLoading : async function(input) {
			let qrCode = encodeURIComponent(this.partNumberQrCode)
			await Repacking.getPartList(this, qrCode, this.repackingId)
			.then(result => {
				if (result != null) {
					this.parts = result
				}
			})
			.catch(error => {});
		},
		async scanPartNumber() {
			let qrCode = encodeURIComponent(this.partNumberQrCode);
			let this_ = this;
			await Repacking.getPartList(this, qrCode, this.repackingId)
			.then(async function(response){
				if(response != null) {
					let result = response;
					if (result.length > 0) {
						this_.selectedPart = result[0];
						this_.goToNext(2, this_.selectedPart);
						return;
					}
				}
				this_.toast({message: 'Part not found!', title:'Error', variant : 'danger'});
				this_.partNumberQrCode = '';
				this_.getPartsWithoutLoading();
			})
			.catch(error => {
				console.log('Scan Part Number', error);
				this_.toast({message: 'Part not found!', title:'Error', variant : 'danger'});
				this.partNumberQrCode = '';
				this_.getPartsWithoutLoading();
			});
		},
		getDeliveryOrders : async function(input) {
			this.isDeliveryOrderLoading = true;
			let qrCode = encodeURIComponent(this.doQrCode)
			return await Repacking.getDeliveryOrderList(this, qrCode, this.selectedPart.id, this.repackingId)
			.then(result => {
				if (result != null) {
					this.deliveryOrders = result
				}
				this.isDeliveryOrderLoading = false;
				this.doQrCode = '';
			})
			.catch(error => {});
		},
		getDeliveryOrdersWithoutLoading : async function(input) {
			let qrCode = encodeURIComponent(this.doQrCode)
			await Repacking.getDeliveryOrderList(this, qrCode, this.selectedPart.id, this.repackingId)
			.then(result => {
				this.deliveryOrders = []
				if (result != null) {
					this.deliveryOrders = result
				}
			})
			.catch(error => {});
		},
		async scanDeliveryOrder() {
			let qrCode = encodeURIComponent(this.doQrCode);
			let this_ = this;
			await Repacking.getDeliveryOrderList(this, qrCode, this.selectedPart.id, this.repackingId)
			.then(async function(response){
				if(response != null) {
					let result = response;
					if (result.length > 0) {
						this_.selectedDeliveryOrder = result[0];
						this_.goToNext(3, this_.selectedDeliveryOrder);
						return;
					}
				}
				this_.toast({message: 'Delivery Order not found!', title:'Error', variant : 'danger'});
				this.doQrCode = '';
			})
			.catch(error => {
				console.log('scanDeliveryOrder', error);
				this_.toast({message: 'Delivery Order not found!', title:'Error', variant : 'danger'});
				this.doQrCode = '';
			});
		},
		gotoPrevious(page) {
			this.scanPageIndex = page;
		},
		goToNext(page, item) {
			if(page == 2) {
				this.selectedPart = item;
				this.getDeliveryOrders();
				this.scanPageIndex = page;
				this.$forceUpdate();
				this.partNumberQrCode = '';
				this.doQrCode = '';
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-delivery-order");
				});
			}
			else if (page == 3) {
				this.selectedDeliveryOrder = item;
				this.$router.replace({ name: 'repackingscan', params : { id: item.repackingDetailId } });
			}
		},
		handleScroll() {
			this.$refs.repackingInput.scrollTop = 0;
		},
		onHidden() {
			this.getRepackings();
		},
		resetModal(modalType) {
			this.isShowPopupUploadRepackingDetail = false; 
			this.isShowPopupRepackingDetail = false; 
			this.deliveryInstructionQrCode = '';
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterRepacking = new RepackingFilter();
		this.filterRepackingDetail = new RepackingDetailFilter();
		this.filterRepackingControlCard = new RepackingControlCardFilter();
		//this.getRepackings();
		//this.getDeliveryInstructionDetails();
		//this.getParts();
		//this.getRepackStatuss();
		//this.getUserInfos();
		//this.getRepackingDetails();
		//this.getControlCards();
		//this.getDeliveryInstructions();
	},
	async mounted(){
		this.repackingId = this.$route.params.id;
		// if (id != '' && id != null && id != undefined) {
		// 	this.modelId = id;
		// 	this.getRepacking(id);
		// }

		await this.getParts();

		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
			this.$nextTick(() => {
				this.focusInput(this, "fieldset-part-number");
			});
		});
	},
	computed: {
	},
	watch : {
		scanPageIndex() {
			this.hideToast();
		}
	},
}
</script>
